<template>
  <header id="toast_header" :class="{ 'is_hover': isHover, 'is_fixed': isFixed}" @mouseover="hoverGnb(true)" @mouseout="hoverGnb(false)">
    <web-optimum-alarm v-if="!isMobile" />
    <!-- [D]스크롤시 header에 is_fixed, 마우스 오버시 is_hover 클래스 추가 -->
    <div class="inner">
      <gnb-logo :showToastLogo="showToastLogo" :toastLogo="toastLogo" :logo="logo" :isDefaultSetting="isDefaultSetting" />
      <!-- [D] global navigation bar -->
      <gnb-header-menu-mobile v-if="isMobile" :gnbMenus="computedGnbMenus" :enableUserMenu="enableUserMenu" />
      <gnb-header-menu v-else :gnbMenus="computedGnbMenus" />
      <!-- //[D] global navigation bar -->
      <gnb-header-side-menu :isDefaultSetting="isDefaultSetting" :enableSearch="enableSearch" :enableChangeLocale="enableChangeLocale" :enableUserMenu="enableUserMenuForSideMenu"
        :joinButton="joinButton" :enableNewsletter="isJp ? false : enableNewsletter" />
      <button v-if="isMobile" type="button" class="btn_gnb" @click="setShowGnb(!showGnb)">{{ $t('gnb.toggle-show-gnb') }}</button>
    </div>
  </header>
</template>

<script>
import Vue from 'vue'
import { from } from 'rxjs'
import { tap } from 'rxjs/operators'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { isEmpty, first } from 'lodash-es'
import URLSearchParams from 'url-search-params'

import { namespace, types } from '../../store/modules/session-store'
import { namespace as gnbNamespace, types as gnbTypes } from '../../store/modules/gnb-store'
import { namespace as commonNamespace, types as commonTypes } from '../../store/modules/common-store'

import WebOptimumAlarm from '../gnb/WebOptimumAlarm'
import GnbHeaderCommon from './header/GnbHeaderCommon'
import GnbLogo from './header/GnbLogo'
import GnbHeaderMenu from './header/GnbHeaderMenu'
import GnbHeaderMenuMobile from './header/GnbHeaderMenuMobile'
import GnbHeaderSideMenu from './header/GnbHeaderSideMenu'
import ServiceMenu from '../service/ServiceMenu'
import MarketPlaceMenu from '../marketplace/MarketPlaceMenu'
import ConsoleAppDownloadOnHeader from './header/ConsoleAppDownload'

export default {
  mixins: [GnbHeaderCommon],
  props: {
    serviceCountryList: {
      type: Array,
      default: () => ['KR']
    },
    showToastLogo: {
      type: Boolean,
      default: false
    },
    toastLogo: {
      type: Object,
      default: () => {
        return {
          default: true,
          white: envs.logo.white,
          color: envs.logo.color,
          mobile: envs.logo.mobile
        }
      }
    },
    logo: {
      type: Object,
      default: () => {
        return {
          default: true,
          white: envs.logo.white,
          color: envs.logo.color,
          mobile: envs.logo.mobile
        }
      }
    },
    gnbMenus: {
      type: Array,
      default: () => {
        return [
          {
            type: 'link',
            messageId: 'gnb.intro.title',
            url: `${mode == 'homepage' ? '' : domain['homepage']}/intro`,
            visible: 'envs.intro.header.enabled',
            subMenuVisible: '!jp && envs.intro.header.submenu.enabled',
            addClass: `${envs.intro.header.class}`,
            subMenus: [
              {
                messageId: 'intro.show-main',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/intro`,
                visible: 'mobile'
              },
              {
                messageId: 'intro.news.title',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/intro/news`,
                visible: '!jp && envs.intro.header.submenu.enabled'
              },
              {
                messageId: 'intro.data-center.title',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/ncc`,
                visible: '!jp && envs.intro.header.submenu.enabled'
              }
            ]
          },
          {
            type: 'link',
            messageId: 'gnb.service.title',
            url: `${mode == 'homepage' ? '' : domain['homepage']}/service`,
            visible: 'true',
            subMenuComponent: ServiceMenu
          },
          {
            type: 'link',
            messageId: 'gnb.marketplace.title',
            url: `${mode == 'homepage' ? '' : domain['homepage']}/marketplace`,
            visible: 'envs.marketplace.header.enabled',
            subMenuComponent: MarketPlaceMenu
          },
          {
            type: 'link',
            messageId: 'gnb.solution.title',
            url: `${mode == 'homepage' ? '' : domain['homepage']}/solutions`,
            visible: 'envs.solution.header.enabled',
            addClass: `${envs.solution.header.class}`,
            subMenus: [
              {
                messageId: 'solution.show-main',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/solutions`,
                visible: 'mobile'
              },
              {
                messageId: 'solution.finance.name',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/solutions/finance`,
                visible: '!jp'
              },
              {
                messageId: 'solution.commerce.name',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/solutions/commerce`,
                visible: '!jp'
              },
              // {
              //   messageId: 'solution.security.name',
              //   url: `${mode == 'homepage' ? '' : domain['homepage']}/solutions/security`,
              //   hide: ['JP']
              // },
              {
                messageId: 'solution.game.name',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/solutions/game`,
                visible: 'true'
              }
            ]
          },
          {
            type: 'link',
            messageId: 'gnb.pricing.title',
            url: `${mode == 'homepage' ? '' : domain['homepage']}/pricing`,
            visible: 'true',
            subMenuVisible: 'envs.pricing.header.submenu.enabled',
            addClass: `${envs.pricing.header.class}`,
            subMenus: [
              {
                messageId: 'pricing.show-main',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/pricing`,
                visible: 'mobile'
              },
              {
                messageId: 'pricing.by-region.name',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/pricing/by-region`,
                visible: '!mobile'
              },
              {
                messageId: 'pricing.by-service.name',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/pricing/by-service`,
                visible: 'true'
              },
              {
                messageId: 'pricing.calculator.name',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/pricing/calculator`,
                visible: '!mobile'
              }
            ]
          },
          {
            type: 'link',
            messageId: 'gnb.customer-story.title',
            url: `${mode == 'homepage' ? '' : domain['homepage']}/customer-stories`,
            visible: 'envs.customer_story.header.enabled',
            addClass: `${envs.customer_story.header.class}`,
            subMenus: [
              {
                messageId: 'customer-story.webservice.show-all',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/customer-stories`,
                visible: 'mobile'
              },
              {
                messageId: 'customer-story.finance-or-public.name',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/customer-stories/finance-or-public`,
                visible: 'true'
              },
              {
                messageId: 'customer-story.general.name',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/customer-stories/general`,
                visible: 'true'
              },
              {
                messageId: 'customer-story.commerce.name',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/customer-stories/commerce`,
                visible: 'true'
              },
              {
                messageId: 'customer-story.game.name',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/customer-stories/game`,
                visible: 'true'
              }
            ]
          },
          {
            type: 'link',
            messageId: 'gnb.partner.title',
            url: `${mode == 'homepage' ? '' : domain['homepage']}/partner`,
            visible: 'envs.partner.header.enabled && !mobile'
          },
          {
            type: 'link',
            messageId: 'gnb.edu.title',
            url: `${mode == 'homepage' ? '' : domain['homepage']}/edu`,
            visible: 'envs.edu.enabled && !jp'
          },
          {
            type: 'link',
            messageId: 'gnb.support.title',
            url: `${mode == 'homepage' ? '' : domain['homepage']}/support`,
            visible: 'true',
            addClass: `${envs.support.header.class}`,
            subMenus: [
              {
                messageId: 'gnb.support.links.show-all',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/support`,
                visible: 'mobile'
              },
              {
                messageId: 'gnb.support.links.faq',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/support/faq`,
                visible: 'true'
              },
              {
                messageId: 'gnb.support.links.inquiry',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/support/inquiry`,
                visible: 'true'
              },
              {
                messageId: 'gnb.support.links.my_qna',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/support/my_qna`,
                visible: 'true'
              },
              {
                messageId: 'gnb.support.links.notice',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/support/notice`,
                visible: 'true'
              },
              {
                messageId: 'gnb.support.links.report',
                url: `${mode == 'homepage' ? '' : domain['homepage']}/support/report`,
                visible: 'envs.support.report.enabled && !jp'
              }
            ]
          },
          {
            type: 'link',
            messageId: 'gnb.user-guide.title',
            url: `${domain['document']}`,
            isBlank: true,
            isExternal: true,
            visible: '!mobile'
          },
          {
            type: 'link',
            content: 'Meetup',
            url: `${domain['meetup']}`,
            isBlank: true,
            isExternal: true,
            showIcoLink: true,
            visible: 'mobile'
          },
          {
            type: 'button',
            content: 'CONSOLE',
            url: `${domain['console']}`,
            isBlank: true,
            isExternal: true,
            showIcoLink: true,
            rightSideMenuComopnent: envs.console.header.rightComponent.enabled? ConsoleAppDownloadOnHeader : null,
            visible: '!mobile'
          }
        ]
      }
    },
    enableSearch: {
      type: Boolean,
      default: envs.search.header.enabled
    },
    enableChangeLocale: {
      type: Boolean,
      default: true
    },
    enableUserMenu: {
      type: Boolean,
      default: true
    },
    joinButton: {
      type: Object,
      default: () => {
        return {
          show: true,
          url: ''
        }
      }
    },
    enableNewsletter: {
      type: Boolean,
      default: false
    },
    hovered: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scrolled: false
    }
  },
  watch: {
    $route: function() {
      this.setHoverGnb(false)
      from(this.computedGnbMenus).subscribe(gnbMenu => {
        this.$set(gnbMenu, 'hover', false)
      })
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
    if (mode !== 'homepage') {
      const isServicedOneCountry = this.serviceCountryList.length === 1
      const checkSession$ = isServicedOneCountry ? this.checkSessionWithTargetedCountry$ : this.checkSessionWithCountry$
      checkSession$()
        .pipe(
          tap(({ countryCode }) => {
            const urlParams = new URLSearchParams(window.location.search)
            const queryLang = urlParams.get('lang')
            this.setUserLocaleByRule({ queryLang, countryCode })
          })
        )
        .subscribe()
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapMutations(namespace, [types.SET_USER_LOCALE, types.SET_USER_COUNTRY]),
    ...mapMutations(gnbNamespace, [gnbTypes.SET_HOVER_GNB, gnbTypes.SET_HOVER_CUSTOM_MENU, gnbTypes.SET_SHOW_GNB]),
    ...mapMutations(commonNamespace, [commonTypes.SET_MOBILE]),
    ...mapActions(namespace, [types.GET_SESSION_WITH_COUNTRY, types.GET_SESSION_AND_SET_TARGET_COUNTRY, types.SET_USER_LOCALE_BY_RULE]),
    handleScroll(event) {
      this.scrolled = window.scrollY > 0 || window.pageYOffset > 0
    },
    hoverGnb(hover) {
      if (this.isMenuHover && !hover) {
        return
      }
      this.setHoverGnb(hover)
    },
    checkSessionWithTargetedCountry$() {
      const countryCode = first(this.serviceCountryList)
      return from(this.getSessionAndSetTargetCountry({ countryCode: countryCode }))
    },
    checkSessionWithCountry$() {
      return from(this.getSessionWithCountry())
    },
    gnbSortMenu(menu, sortMap, lang) {
      const map = {}
      menu.subMenus.forEach(subMenu => {
        map[subMenu.messageId] = subMenu
      })
      const targetMap = sortMap[lang] || sortMap.KR

      Vue.set(
        menu,
        'subMenus',
        targetMap.map(subMenuId => {
          return map[subMenuId]
        })
      )
      return menu
    }
  },
  computed: {
    ...mapState(namespace, ['session', 'userLocale', 'locales']),
    ...mapState(gnbNamespace, ['hover', 'showGnb']),
    ...mapGetters(gnbNamespace, [gnbTypes.IS_MENU_HOVER]),
    ...mapState(commonNamespace, ['isMobile']),
    isDefaultSetting() {
      return isEmpty(this.$options.propsData.gnbMenus)
    },
    isHover() {
      return !this.isMobile && (this.hovered || this.hover.gnb)
    },
    isFixed() {
      if (this.isMobile) {
        return false
      }
      return this.fixed || this.scrolled || (this.canUseRoute && this.$route.meta.fixedHeader)
    },
    enableUserMenuForSideMenu() {
      return this.isMobile ? false : this.enableUserMenu
    },
    computedGnbMenus() {
      return this.gnbMenus.map(menu => {
        // customer story
        if (menu.messageId === 'gnb.customer-story.title') {
          const sortMap = {
            KR: [
              'customer-story.webservice.show-all',
              'customer-story.finance-or-public.name',
              'customer-story.general.name',
              'customer-story.commerce.name',
              'customer-story.game.name'
            ],
            JP: [
              'customer-story.webservice.show-all',
              'customer-story.game.name',
              'customer-story.general.name',
              'customer-story.commerce.name',
              'customer-story.finance-or-public.name'
            ]
          }
          return this.gnbSortMenu(menu, sortMap, this.countryCode)
        } else {
          return menu
        }
      })
    }
  },
  components: { WebOptimumAlarm, ServiceMenu, MarketPlaceMenu, GnbLogo, GnbHeaderMenu, GnbHeaderMenuMobile, GnbHeaderSideMenu }
}
</script>
